/**
 * View for configuring the KB contexts as part of the KB creation wizard
 */
define([
  "marionette",
  "modules/accountAdmin/kbWizardModal/kbContexts/template/kbContextsTemplate.html",
], function (Marionette, KbContextsTemplate) {
  var KbContextsView = {};

  KbContextsView.kbContextsLayout = Marionette.Layout.extend({
    template: KbContextsTemplate,
    regions: {
      list: "#kbContextList",
    },
    triggers: {
      "click #addContext": "addContext",
    },
    onRender: function () {
      var _this = this;
      this.$el.i18n();
      this.$el.find("input").on("keyup", function (e) {
        if (e.keyCode === 13) {
          _this.trigger("addContext");
        }
      });
    },
    getContext: function () {
      return this.$el.find("#contextName").val().trim();
    },
    clearContext: function () {
      this.$el.find("#contextName").val("");
    },
    contextError: function (errorMessage) {
      this.$el
        .find("#contextError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    clearErrors: function () {
      this.$el.find("#contextError").html("");
    },
  });

  return KbContextsView;
});
